import axios from 'axios';
import jsonp from 'jsonp';
import queryString from 'query-string';
import Config from '../../../config';
import { budgets, budgetInts, interests, localeToMarket, sources } from './consts';

const subscribeToNewsLetter = ({ email, setSuccess, setError }) => {
    const formData = {
        EMAIL: email,
    };

    // We have to do it like this, since the other solution would be displaying API key publicly
    // and also mailchimp blocks the clientside API requests
    jsonp(`${Config.api.signupNewsLetter}${queryString.stringify(formData)}`, { param: 'c' }, (error, data) => {
        if (error) {
            setError(error);
            console.log(error);
        }
        if (!error && data) {
            setSuccess(true);
        }
    });
};

export const sendInquiry = async ({
    values,
    setApiError,
    setSubmitting,
    setSuccess,
    setProgress,
    setNewsLetterSuccess,
    setNewsLetterError,
    resetForm,
    locale,
}) => {
    setSubmitting(true);
    setProgress(0);
    setSuccess(null);
    setApiError(null);

    if (values.newsLetter) {
        setNewsLetterSuccess(null);
        setNewsLetterError(null);

        subscribeToNewsLetter({
            email: values.email,
            setSuccess: setNewsLetterSuccess,
            setError: setNewsLetterError,
        });
    }

    const formData = new FormData();

    Object.entries(values).forEach(([key, value]) => {
        switch (key) {
            case 'budget': {
                formData.set(key, budgets[locale][value]);
                formData.set(`budgetInt`, budgetInts[locale][value]);
                formData.set(`value`, budgetInts[locale][value] ?? 0);
                break;
            }
            case 'files': {
                value.forEach((file, index) => formData.set(`uploaded_file${index}`, file, file.name));
                break;
            }
            case 'interestedIn': {
                formData.set(key, interests[value]);
                break;
            }
            case 'description': {
                if (values.source === sources.other) {
                    formData.set('description', `${value}\n\n\nOther inquiry source: ${values.otherSource || 'n/a'}`);
                } else {
                    formData.set(key, value);
                }
                break;
            }
            case 'otherSource': {
                break;
            }
            default: {
                formData.set(key, value);
                break;
            }
        }
    });

    formData.set('origin', 'Contact form');
    formData.set(`formSource`, locale);
    formData.set(`_subject`, `New inquiry from ${values.name}`);
    formData.set(`_replyto`, values.email);

    formData.set(`market`, localeToMarket[locale]);

    try {
        await axios({
            method: 'POST',
            url: Config.api.sendInquiryForm,
            data: formData,
            onUploadProgress: progressEvent =>
                setProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total)),
        });

        setSubmitting(false);
        setSuccess(true);
        setApiError(false);
        setProgress(100);
        resetForm();
    } catch (error) {
        setSubmitting(false);
        setSuccess(false);
        setApiError(error);
        setProgress(100);
        console.log(error);
    } finally {
        setProgress(100);
    }
};
